import {PlayerValidator} from '@colonist/game-mechanic-validators'
import {UIGameManager} from '../../../../shared/scripts/ui_game/UIGameManager'
import {UIGameCardWithRatioContainerView} from '../../../../shared/scripts/ui_game/ui_game_card/UIGameCardWithRatioContainerView'
import {UIMGamePlayerCardsAnimationController} from './UIMGamePlayerCardsAnimationController'
import {SectionBgView} from '../../../../shared/scripts/ui_canvas_engine/SectionBgView'
import {CardEnum, PlayerColor} from '@colonist/game-states'

interface UIGamePlayerCardExchangeMapping {[key: string]: UIMGamePlayerCardsAnimationController}

export class UIMGameCardExchangeAnimationController {
    private readonly exchangeViewForPlayer: UIGamePlayerCardExchangeMapping = {}
    private readonly exchangeViewContainerView: SectionBgView

    constructor(uiGameManager: UIGameManager, cardContainerView: UIGameCardWithRatioContainerView) {
        const canvas = uiGameManager.canvasController
        const playerBoxHeight = uiGameManager.playersController.opponentsScrollbox.height
        this.exchangeViewContainerView = new SectionBgView(0, 0, canvas.appW, playerBoxHeight, canvas.app.stage)
        this.exchangeViewContainerView.interactiveChildren = false
        uiGameManager.gameState.players.forEach((player: PlayerValidator) => {
            this.exchangeViewForPlayer[player.color] = new UIMGamePlayerCardsAnimationController(uiGameManager, this.exchangeViewContainerView, player.color, cardContainerView)
        })
    }

    animateCardExchange(player: PlayerColor, receivingCards: CardEnum[], givingCards: CardEnum[]) {
        const animationController = this.exchangeViewForPlayer[player]
        animationController?.animateCardExchange(receivingCards, givingCards)
    }

    discardCardExchange(player: PlayerColor, givingCards: CardEnum[]) {
        const animationController = this.exchangeViewForPlayer[player]
        animationController?.discardCards(givingCards)
    }
}
